export default "__VITE_ASSET__DeX4xrE___"